<div class="portal-table-footer-standard">
  <span class="portal-table-footer-standard__count">
    Showing {{ from }} to {{ to }} of {{ total || 0 }}
  </span>

  <div class="portal-table-footer-standard__pagination">
    <button type="button" [disabled]="currentPage <= 1" (click)="previousPage()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button
      type="button"
      *ngFor="let page of pageNumbers; trackBy: trackByPage"
      [class.active]="page === currentPage"
      (click)="setPage(page)">
      {{ page }}
    </button>
    <button type="button" [disabled]="currentPage >= totalPages" (click)="nextPage()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="portal-table-footer-standard__rows-per-page">
    <span>{{ rowsLabel }}</span>
    <button type="button" [matMenuTriggerFor]="rowsMenu">
      {{ pageSize }}
      <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu #rowsMenu="matMenu" class="portal-table-footer-standard__menu">
      <button
        mat-menu-item
        type="button"
        *ngFor="let option of pageSizeOptions"
        (click)="setRowsPerPage(option)">
        {{ option }}
      </button>
    </mat-menu>
  </div>
</div>
